import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { form, required, email, maxLength, FormField } from '@angular/forms/signals';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';

type LoginScope = 'admin' | 'super-admin' | 'model-admin';

interface LoginModel {
  email: string;
  password: string;
}

@Component({
  selector: 'login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormField, MatFormField, MatLabel, TranslateDirective, MatInput, MatButton, TranslatePipe],
})
export class LoginFormComponent {
  readonly scope = input<LoginScope>('admin');
  readonly scopeLabelKey = input('login-scope-admin');
  readonly userData = output<{ email: string; password: string }>();
  readonly scopeSubmit = output<LoginScope>();

  readonly model = signal<LoginModel>({
    email: '',
    password: '',
  });

  readonly loginForm = form(this.model, path => {
    required(path.email);
    email(path.email);
    required(path.password);
    maxLength(path.password, 128);
  });

  submitUserData(event: Event) {
    event.preventDefault();
    this.userData.emit(this.model());
  }

  submitScope() {
    this.scopeSubmit.emit(this.scope());
  }
}
